// extracted by mini-css-extract-plugin
export default {"letterpressMessage":"letterpressMessage__2DWii","sampleFlowDateField":"sampleFlowDateField__3hE1u","optional":"optional__lxkHl"};